module.exports = __webpack_public_path__ + "img/en.c428e6d4.jpg";